import { FieldLabel } from '@calendly/form/parts'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'

export const Label = () => (
  <FieldLabel
    htmlFor="location-list"
    text={I18n.t('publisher.event_types.location.location')}
    proTip={HtmlParser(I18n.t('publisher.event_types.location.location_tooltip_html'))}
  />
)
